import React from 'react';
import { CaretRightOutlined } from '@ant-design/icons';

import IntroductionSection from './IntroductionSection';
import ResearchThemePage from './ResearchTheme';
import ResearchAndNewsSection from './ResearchAndNewsSection';
import ExperienceAndContactSection from './ExperienceAndContactSection';
import LifePage from './LifePage';
import DataArtSection from './DataArtSection';
import MediaCoverageSection from './MediaCoverageSection';


interface HomePageProps {
  textContent: any;
}

const HomePage: React.FC<HomePageProps> = (props) => {
  const { textContent } = props;
  return (
    <>
      <IntroductionSection textContent={textContent} />
      <ResearchThemePage />
      <ResearchAndNewsSection />
      <MediaCoverageSection textContent={textContent} />
      <DataArtSection textContent={textContent} />
      <ExperienceAndContactSection />
      <LifePage />
     </>
  )
};

export default HomePage;